"use strict";

exports.__esModule = true;
var _NewLogbookTicket = require("./NewLogbookTicket");
Object.keys(_NewLogbookTicket).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NewLogbookTicket[key]) return;
  exports[key] = _NewLogbookTicket[key];
});
var _NewLogbookTicketForm = require("./NewLogbookTicketForm");
Object.keys(_NewLogbookTicketForm).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NewLogbookTicketForm[key]) return;
  exports[key] = _NewLogbookTicketForm[key];
});